import { render } from "./MarketsAnalytics.vue?vue&type=template&id=eae8a048&scoped=true"
import script from "./MarketsAnalytics.vue?vue&type=script&lang=js"
export * from "./MarketsAnalytics.vue?vue&type=script&lang=js"

import "./MarketsAnalytics.vue?vue&type=style&index=0&id=eae8a048&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eae8a048"]])

export default __exports__